// components/RegionSelector.js
export default function RegionSelector({
  regions, // This is now an array from the API, e.g., response.segments
  selectedRegions,
  setSelectedRegions,
  imageWidth,
  imageHeight,
}) {
  const selected = selectedRegions || {};

  const toggleRegion = (regionId) => {
    setSelectedRegions((prev) => {
      const current = prev || {};
      const isSelected = current[regionId];
      const next = Object.fromEntries(
        regions.map((region) => [region.id, false]),
      );
      if (!isSelected) next[regionId] = true;
      return next;
    });
  };


  // Ensure regions is an array to prevent crashes
  if (!Array.isArray(regions)) return null;


  return (
    <>
      {regions.map((region) => {
        if (!region?.bbox || !imageWidth || !imageHeight) return null;

        // Since the API uses 'bbox', we calculate the center from there
        const x = region.bbox.x + region.bbox.w / 2;
        const y = region.bbox.y + region.bbox.h / 2;


        const left = (x / imageWidth) * 100;
        const top = (y / imageHeight) * 100;


        return (
          <div
            key={region.id} // Use the unique ID from the API
            className="absolute flex items-center gap-2"
            style={{
              left: `${left}%`,
              top: `${top}%`,
              transform: "translate(-50%, -50%)",
            }}
          >
            <input
              type="checkbox"
              checked={!!selected[region.id]}
              onChange={() => toggleRegion(region.id)}
              className="w-5 h-5 accent-blue-500"
            />


            <span className="text-white text-xs bg-black/70 px-2 py-1 rounded">
              {region.id.replaceAll("_", " ")}
            </span>
          </div>
        );
      })}
    </>
  );
}
